module.exports = __webpack_public_path__ + "static/assets/8240bbaffb7601cf6a60c064b30c95ae.jpg";